import { AdditionalHeader } from './core/baseRequest';
import { TokenRequest } from './tokenRequest';
import { objectToUrlEncodedString } from './core/formEncodedDataHelper';
import { LoginPageVariant } from 'acscp/store/loginPageVariant';

export class PasswordTokenRequest extends TokenRequest {
    constructor(username: string, public password: string, public loginPageVariant: LoginPageVariant = LoginPageVariant.JetPortal) {
        super(username);
    }

    protected buildRequestInit(additionalHeaders: AdditionalHeader[]): RequestInit {
        return {
            ...super.buildRequestInit(additionalHeaders),
            method: 'POST',
            body: objectToUrlEncodedString({
                grant_type: 'password',
                username: this.username,
                password: this.password,
                client_id: this.clientId
            })
        };
    }
}
